"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("../util");
var ShutdownMonitor = /** @class */ (function () {
    function ShutdownMonitor() {
        this.__isReporting = false;
        this.__listener = this.makeListener();
    }
    ShutdownMonitor.prototype.setClient = function (client) {
        this.__client = client;
    };
    ShutdownMonitor.prototype.makeListener = function () {
        var _this = this;
        // noinspection UnnecessaryLocalVariableJS
        var honeybadgerShutdownListener = function (signal) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.__isReporting || !this.__client) {
                            return [2 /*return*/];
                        }
                        this.__isReporting = true;
                        return [4 /*yield*/, this.__client.flushAsync()];
                    case 1:
                        _a.sent();
                        this.__isReporting = false;
                        if (!this.hasOtherShutdownListeners(signal)) {
                            (0, util_1.fatallyLogAndExitGracefully)(signal);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        return honeybadgerShutdownListener;
    };
    ShutdownMonitor.prototype.maybeAddListener = function () {
        for (var _i = 0, _a = ShutdownMonitor.KILL_SIGNALS; _i < _a.length; _i++) {
            var signal = _a[_i];
            var signalListeners = process.listeners(signal) || [];
            if (!signalListeners.includes(this.__listener)) {
                process.on(signal, this.__listener);
            }
        }
    };
    ShutdownMonitor.prototype.maybeRemoveListener = function () {
        for (var _i = 0, _a = ShutdownMonitor.KILL_SIGNALS; _i < _a.length; _i++) {
            var signal = _a[_i];
            var signalListeners = process.listeners(signal) || [];
            if (signalListeners.includes(this.__listener)) {
                process.removeListener(signal, this.__listener);
            }
        }
    };
    ShutdownMonitor.prototype.hasOtherShutdownListeners = function (signal) {
        var _this = this;
        var otherListeners = (process.listeners(signal) || [])
            .filter(function (listener) { return listener !== _this.__listener; });
        return otherListeners.length > 0;
    };
    // SIGTERM is raised by AWS Lambda when the function is being shut down
    // SIGINT is raised by the user pressing CTRL+C
    ShutdownMonitor.KILL_SIGNALS = ['SIGTERM', 'SIGINT'];
    return ShutdownMonitor;
}());
exports.default = ShutdownMonitor;
//# sourceMappingURL=shutdown_monitor.js.map